import { IArpMedia } from '../../arp-registry/ArpMedia'
import { arpIsTokenGated } from '../functions'
import { useIsArpTokenGateHolder } from './useIsArpTokenGateHolder'

export const useArpTokenGate = (arp: IArpMedia) => {
  const { isHolder, status: isHolderStatus } = useIsArpTokenGateHolder(arp)
  const isTokenGated = arpIsTokenGated(arp)

  const isLoading = isHolderStatus === 'loading'
  const canAccessArp = isTokenGated ? isHolder : true
  return { canAccessArp, isLoading }
}
